/* eslint-disable react-hooks/exhaustive-deps */
import Accordion from 'SpendController/Components/Accordian/Accordian';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	Header,
	HeaderSpan,
	InnerContainer,
	RefreshSpan,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	combinePreWorkshopBaselineKpiData,
	combinePreWorkshopData,
	MICROTAIL_BASELINE_KPI_DATA,
	MICROTAIL_PRELIMINARY_SAVINGS_KPI_DATA,
	MICROTAIL_VENDOR_KPI_DATA,
	combineMicroTailVendorData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	getMicroTailBaselineSummaryKpis,
	getMicroTailPreliminarySavingsSummary,
	getMicroTailVendorActionKpis,
} from 'utils/apiRequests';

function MicroTailLaunch() {
	const [microTailBaselineKpiData, setMicroTailBaselineKpiData] = useState(
		MICROTAIL_BASELINE_KPI_DATA
	);
	const [microTailVendorKpiData, setMicroTailVendorKpiData] = useState(
		MICROTAIL_VENDOR_KPI_DATA
	);
	const [microPreliminaryKpiData, setMicroPreliminaryKpiData] = useState(
		MICROTAIL_PRELIMINARY_SAVINGS_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSpendType = ['MICRO'];
	const {
		filters,
		microLaunchColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
	} = useSpendControllerFiltersContext();

	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MICRO'];
		realTime && setIsLoading(true);
		const microTailBaselineKpiDataResponse = await getMicroTailBaselineSummaryKpis(
			microFilters
		);
		const microTailVendorActionResponse = await getMicroTailVendorActionKpis(
			microFilters
		);
		const microTailPreliminaryKpiResponse = await getMicroTailPreliminarySavingsSummary(
			microFilters
		);
		const tempMicroTailBaselineKpiData = combinePreWorkshopBaselineKpiData(
			microTailBaselineKpiDataResponse.data,
			microTailBaselineKpiData.data
		);
		setMicroTailBaselineKpiData({
			...microTailBaselineKpiData,
			data: tempMicroTailBaselineKpiData,
		});
		const newWorkShopKpiData = combinePreWorkshopData(
			microTailPreliminaryKpiResponse,
			microPreliminaryKpiData.data
		);
		setMicroPreliminaryKpiData({
			...microPreliminaryKpiData,
			data: newWorkShopKpiData,
		});

		const tempMicroTailVendorData = combineMicroTailVendorData(
			microTailVendorActionResponse,
			microTailVendorKpiData.data
		);
		setMicroTailVendorKpiData({
			...microTailVendorKpiData,
			data: tempMicroTailVendorData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<BreakDownFilters />

			<InnerContainer>
				<Accordion name={`Micro Tail Template  Health Bar`} idkey={'acc1'}>
					<InnerContainer>
						<Summary {...microTailBaselineKpiData} />
						<Summary {...microTailVendorKpiData} />
						<Summary {...microPreliminaryKpiData} />
					</InnerContainer>
				</Accordion>
			</InnerContainer>
			<ColumnContainer>
				<Header>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableWrapper n={7}>
					<TableView
						data={microLaunchColumnDefs}
						columnDefs={microLaunchColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default MicroTailLaunch;
